import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const WoundCareTransfer = ({ onNext, onBack, onDataChange }) => {
  const [transferCriteria, setTransferCriteria] = useState({});
  const [documentationChecklist, setDocumentationChecklist] = useState({});
  const [woundCareNotes, setWoundCareNotes] = useState('');

  const transferItems = [
    'Partial thickness burns greater than 10% TBSA',
    'Burns involving face, hands, feet, genitalia, or major joints',
    'Third-degree burns in any age group',
    'Electrical burns, including lightning injury',
    'Chemical burns'
  ];

  const documentationItems = [
    'Burn assessment (depth, TBSA)',
    'Wound care procedures',
    'Transfer criteria assessment',
    'Patient response to interventions',
    'Consultations and referrals'
  ];

  const handleNext = () => {
    const data = { transferCriteria, documentationChecklist, woundCareNotes };
    if (onDataChange) {
      onDataChange({ wound_care_transfer: data });
    }
    onNext();
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-black py-4">
      <div className="w-full max-w-sm mx-auto px-4">
        <div className="flex flex-col min-h-screen bg-zinc-900 rounded-3xl border-2 border-orange-500/30 shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between p-4 border-b-2 border-orange-500/30">
            <Button onClick={onBack} variant="ghost" className="flex items-center gap-2 text-orange-500 text-lg font-bold">
              <ArrowLeft className="w-6 h-6" /> Back
            </Button>
            <h1 className="text-lg font-black text-orange-500">Wound Care & Transfer</h1>
            <div className="w-20" />
          </div>

          <main className="flex-1 px-4 pt-4 pb-20 bg-black overflow-y-auto space-y-5">
            {/* Wound Care */}
            <section>
              <h2 className="text-2xl font-black text-orange-400 mb-3">Wound Care</h2>
              <div className="space-y-3 rounded-2xl bg-zinc-900 p-4 border-2 border-orange-500/20">
                <div>
                  <h3 className="font-bold text-lg text-orange-300">Initial Assessment</h3>
                  <p className="text-base text-orange-100 leading-relaxed">Assess depth and extent of burn, noting TBSA and degree</p>
                </div>
                <div>
                  <h3 className="font-bold text-lg text-orange-300">Cleaning and Debridement</h3>
                  <p className="text-base text-orange-100 leading-relaxed">Clean with mild soap and water. Remove dead tissue</p>
                </div>
                <div>
                  <h3 className="font-bold text-lg text-orange-300">Dressing</h3>
                  <p className="text-base text-orange-100 leading-relaxed">Apply appropriate dressings with antimicrobial agents</p>
                </div>
              </div>
              <textarea
                placeholder="Wound care notes..."
                value={woundCareNotes}
                onChange={(e) => setWoundCareNotes(e.target.value)}
                rows="3"
                className="mt-3 w-full rounded-xl bg-zinc-900 border-2 border-orange-500/30 text-base text-orange-100 placeholder-zinc-500 p-4"
              />
            </section>

            {/* Transfer Criteria */}
            <section>
              <h2 className="text-2xl font-black text-orange-400 mb-3">Transfer Criteria (ABA)</h2>
              <div className="space-y-3">
                {transferItems.map((item, index) => (
                  <label key={index} className="flex items-start gap-3">
                    <input
                      type="checkbox"
                      checked={transferCriteria[index] || false}
                      onChange={() => setTransferCriteria(prev => ({ ...prev, [index]: !prev[index] }))}
                      className="mt-1 h-7 w-7 shrink-0 rounded border-2 border-orange-500 bg-transparent checked:bg-orange-500"
                    />
                    <span className="text-lg text-orange-100 leading-snug">{item}</span>
                  </label>
                ))}
              </div>
            </section>

            {/* Documentation Checklist */}
            <section>
              <h2 className="text-2xl font-black text-orange-400 mb-3">Documentation Checklist</h2>
              <div className="space-y-3">
                {documentationItems.map((item, index) => (
                  <label key={index} className="flex items-start gap-3">
                    <input
                      type="checkbox"
                      checked={documentationChecklist[index] || false}
                      onChange={() => setDocumentationChecklist(prev => ({ ...prev, [index]: !prev[index] }))}
                      className="mt-1 h-7 w-7 shrink-0 rounded border-2 border-orange-500 bg-transparent checked:bg-orange-500"
                    />
                    <span className="text-lg text-orange-100 leading-snug">{item}</span>
                  </label>
                ))}
              </div>
            </section>
          </main>

          <div className="fixed bottom-0 left-0 right-0 p-4 bg-zinc-900 border-t-2 border-orange-500/30 max-w-sm mx-auto">
            <Button onClick={handleNext} className="w-full h-14 bg-orange-500 text-white text-lg font-black rounded-xl hover:bg-orange-600 shadow-xl">
              Next <ArrowRight className="w-6 h-6 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WoundCareTransfer;